import { Component, OnInit } from '@angular/core';
import { AppContext } from '../app.context';
import { RouterModule, RouterOutlet } from '@angular/router';

@Component({
  selector: 'app-master',
  templateUrl: './app-master.component.html',
  styleUrls: ['./app-master.component.css'],
  imports: [
    RouterOutlet,
    RouterModule
  ]
})
export class AppMasterComponent implements OnInit {

  constructor(private appContext: AppContext) { }

  ngOnInit() {
  }

  public logOut() : void {
    this.appContext.logOut();
    window.location.assign('/');
  }
}
